export default __webpack_public_path__ + "static/media/logo-fundacion-terpel.c08b7c38.svg";